import React from 'react';
import { TextField } from '@mui/material';
const InputNumber = ({ name, label, value = '', onChange, }) => {
    return React.createElement(TextField, { id: name, name: name, size: "small", value: value, label: label, variant: "outlined", type: 'number', onChange: onChange });
};
export default InputNumber;
